module.exports = __webpack_public_path__ + "static/media/Marker_Light.905f993d.svg";